/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OrderOrderMode = "LIMIT_ORDER" | "MARKET_ORDER" | "%future added value";
export type OrderOrderStatus = "CANCELED" | "EXECUTED" | "PARTIALLY_CANCELED" | "PARTIALLY_COMPLETED" | "PENDING" | "%future added value";
export type OrderOrderType = "BUY" | "SELL" | "%future added value";
export type PortfolioPendingOrderQueryVariables = {|
  orderStatus?: ?string
|};
export type PortfolioPendingOrderQueryResponse = {|
  +allPendingOrders: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +created: any,
        +edited: ?any,
        +stock: {|
          +id: string,
          +name: string,
          +politicianImage: ?string,
          +party: {|
            +partyName: string
          |},
          +price: number,
        |},
        +pendingStockCount: ?number,
        +orderType: OrderOrderType,
        +orderMode: OrderOrderMode,
        +orderStatus: OrderOrderStatus,
        +stockPrice: number,
        +pendingInvested: ?number,
        +quantity: number,
      |}
    |}>
  |}
|};
export type PortfolioPendingOrderQuery = {|
  variables: PortfolioPendingOrderQueryVariables,
  response: PortfolioPendingOrderQueryResponse,
|};
*/


/*
query PortfolioPendingOrderQuery(
  $orderStatus: String
) {
  allPendingOrders(orderStatus: $orderStatus) {
    edges {
      node {
        id
        created
        edited
        stock {
          id
          name
          politicianImage
          party {
            partyName
            id
          }
          price
        }
        pendingStockCount
        orderType
        orderMode
        orderStatus
        stockPrice
        pendingInvested
        quantity
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderStatus"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "orderStatus",
    "variableName": "orderStatus"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "edited",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "politicianImage",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partyName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pendingStockCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderType",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderMode",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderStatus",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stockPrice",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pendingInvested",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioPendingOrderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "OrderNodeConnection",
        "kind": "LinkedField",
        "name": "allPendingOrders",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrderNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrderNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PoliticiansNode",
                    "kind": "LinkedField",
                    "name": "stock",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PartyNode",
                        "kind": "LinkedField",
                        "name": "party",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PortfolioPendingOrderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "OrderNodeConnection",
        "kind": "LinkedField",
        "name": "allPendingOrders",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrderNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrderNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PoliticiansNode",
                    "kind": "LinkedField",
                    "name": "stock",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PartyNode",
                        "kind": "LinkedField",
                        "name": "party",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4315e9d4333f306c7011a9cc8c686f58",
    "id": null,
    "metadata": {},
    "name": "PortfolioPendingOrderQuery",
    "operationKind": "query",
    "text": "query PortfolioPendingOrderQuery(\n  $orderStatus: String\n) {\n  allPendingOrders(orderStatus: $orderStatus) {\n    edges {\n      node {\n        id\n        created\n        edited\n        stock {\n          id\n          name\n          politicianImage\n          party {\n            partyName\n            id\n          }\n          price\n        }\n        pendingStockCount\n        orderType\n        orderMode\n        orderStatus\n        stockPrice\n        pendingInvested\n        quantity\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'aadfcc448ddd8f865ad47718d81918cb';

module.exports = node;
